import React from 'react';
import {useDispatch, useSelector} from 'react-redux';

import {
    FINISH_RESET_FILTERS,
    FINISH_SET_FILTER,
    RESET_FILTERS,
    SET_FILTER,
} from '../Redux/Actions/Types/queryToolActionTypes';
import {useCreateColumn} from './QueryToolColumnHooks';
import {useQueryData} from './QueryToolDataHooks';

export const useUpdateFilter = () => {
    const dispatch = useDispatch();
    const queryData = useQueryData();

    const {isUpdatingFilter} = useSelector(state => state.queryToolState);

    React.useEffect(() => {
        if (isUpdatingFilter) {
            queryData();
            dispatch({type: FINISH_SET_FILTER});
        }
    }, [dispatch, isUpdatingFilter, queryData]);

    return (name, value) => {
        dispatch({type: SET_FILTER, name, value});
    };
};

export const useClearFilters = () => {
    const dispatch = useDispatch();
    const queryData = useQueryData();
    const createColumnObject = useCreateColumn();

    const {isResettingFilters, columns} = useSelector(state => state.queryToolState);

    React.useEffect(() => {
        if (isResettingFilters) {
            queryData();
            dispatch({type: FINISH_RESET_FILTERS});
        }
    }, [dispatch, isResettingFilters, queryData]);

    return () => {
        // TODO: should we set these back to the defaults provided by the API
        // instead of clearing them completely?
        const columnsClone = columns.map((x) => (
            createColumnObject({...x.data, filters: []})
        ));

        dispatch({type: RESET_FILTERS, columns: columnsClone});
    };
};
